module.exports = __webpack_public_path__ + "img/045-renewable-energy.f6286fa0.svg";